// Admin configuration mock data
export const adminSettings = {
  enable_paid_normal_ads: false, // Toggle to enable/disable charging for normal ads
  normal_ad_fee: 500, // Rs 500 per ad
  premium_ad_enabled: true,
  premium_ad_price: 999, // Rs 999 for 3 months
  premium_ad_duration: 90, // 90 days
  payment_gateways: {
    stripe_enabled: true,
    paypal_enabled: true,
    directpay_enabled: true, // For Sri Lankan cards
    frimi_enabled: true
  }
};

// Payment gateway options
export const paymentGateways = [
  {
    id: 'stripe',
    name: 'Credit/Debit Card (International)',
    description: 'Visa, Mastercard, Amex - Worldwide',
    icon: 'CreditCard',
    enabled: true,
    type: 'international'
  },
  {
    id: 'directpay',
    name: 'DirectPay',
    description: 'Sri Lankan Cards (Visa, Master)',
    icon: 'Landmark',
    enabled: true,
    type: 'local'
  },
  {
    id: 'frimi',
    name: 'FriMi',
    description: 'Dialog FriMi Payment',
    icon: 'Smartphone',
    enabled: true,
    type: 'local'
  },
  {
    id: 'paypal',
    name: 'PayPal',
    description: 'International PayPal Payments',
    icon: 'Wallet',
    enabled: true,
    type: 'international'
  }
];

// Google Maps API Key (placeholder - will be set in .env)
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY || 'YOUR_GOOGLE_MAPS_KEY';

// Google Translate API Key (placeholder - will be set in .env)
export const GOOGLE_TRANSLATE_API_KEY = process.env.REACT_APP_GOOGLE_TRANSLATE_KEY || 'YOUR_GOOGLE_TRANSLATE_KEY';